import { useStoreContext } from "../../contexts/store.context"

export const ItemsCount = () => {
    const { pagination, isFetching } = useStoreContext()

    if (isFetching || pagination?.count === undefined) return

    return <b>{pagination.count} ITEMS</b>
}